import Icon from "@/components/icons/Icons";
import React from "react";

export default function RetirementAgeSelector({
  label,
  value,
  min,
  max,
  onChange,
  onBlur,
  valueColor = "text-primaryBlack",
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (v: number) => void;
  onBlur?: (v: number) => void;
  valueColor?: string;
}) {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const raw = Number(e.target.value);
    const safe = isNaN(raw) ? min : raw;
    // Clamp to max; values below min are left for validation to surface as errors
    const clamped = Math.min(max, safe);
    if (clamped !== safe) onChange(clamped);
    onBlur?.(clamped);
  };

  return (
    <div className="space-y-3">
      <p className="text-sm sm:text-base font-medium sm:leading-1.2 text-primaryBlack/60">{label}</p>

      <div className="flex items-center gap-3 sm:gap-6">
        <button
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          className="w-10 h-10 sm:w-half-px sm:h-half-px rounded-xl border border-[#003D6C] bg-[#EAECF4] flex items-center justify-center transition hover:bg-blue-50 shrink-0 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#EAECF4]"
        >
          <Icon.expandableIcon isOpen={true} />
        </button>

        <label className="block space-y-1 w-full border border-[#DBDBDB] bg-white rounded-xl sm:rounded-2xl p-2 sm:p-3.5">
          <input
            type="text"
            inputMode="numeric"
            min={min}
            max={max}
            value={value}
            onChange={(e) => {
              const raw = e.target.value;
              if (raw === "") {
                onChange(0);
                return;
              }
              const num = Number(raw);
              if (isNaN(num)) return;

              onChange(Math.min(num, max));
            }}
            onBlur={handleBlur}
            className={[
              "block border-0 outline-hidden w-full max-w-80 mx-auto text-center text-xl sm:text-2.5xl font-semibold sm:font-bold",
              valueColor,
            ].join(" ")}
          />
          <p className="text-center text-xs text-[#666666]">Years old</p>
        </label>

        <button
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          className="w-10 h-10 sm:w-half-px sm:h-half-px rounded-xl border border-[#003D6C] bg-[#EAECF4] flex items-center justify-center transition hover:bg-blue-50 shrink-0 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#EAECF4]"
        >
          <Icon.expandableIcon />
        </button>
      </div>
    </div>
  );
}
